import React from "react";
import PropTypes from "prop-types";

import "./_styles.css";

const YoutubeEmbed = ({ url, width=853, height=480 }) => (
  <div className="video-responsive">
    <iframe
      width={width}
      height={height}
      src={url}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default YoutubeEmbed;